import jwt from "jsonwebtoken";
import config from "../config";

export function isAuthenticated(token) {
    // We check if app runs with backend mode
    if (!config.isBackend && token) return true;
    if (!token) return false;
    const date = new Date().getTime() / 1000;
    const data = jwt.decode(token);
    if (!data) return false;
    return date < data.exp;
}

export function hasToken() {
    return null != localStorage.getItem('token');
}

export function clearAuthData() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
}

export function setAuthData(token) {
    let user = jwt.decode(token).user;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
}

export function isAuthenticatedWithToken() {
    let token = localStorage.getItem('token');
    return isAuthenticated(token);
}

export const AuthMixin = {
    methods: {
        isAuthenticated,
        isAuthenticatedWithToken,
        clearAuthData,
        hasToken
    }
};
